/**
 * Table Compare Section - Column Shadow Positioning
 * Calculates and positions the shadow element to highlight the first brand column
 */
document.addEventListener('DOMContentLoaded', function() {
  const shadowElement = document.querySelector('.pc-column-shadow');
  const tableRows = document.querySelectorAll('.table-compare .pc-row');

  function updateShadowPosition() {
    if (!shadowElement || tableRows.length === 0) return;

    let totalColumnHeight = 0;
    let columnLeft = 0;
    let columnWidth = 0;

    // Assuming the second div in each row is the target column
    const secondColumnCells = Array.from(tableRows).map(row => row.children[1]);

    if (secondColumnCells.length === 0 || !secondColumnCells[0]) return;

    // Get position and width from the first cell in the column
    const firstCell = secondColumnCells[0];
    if (firstCell) {
      const tableRect = document.querySelector('.table-compare .pc-table_wrapper').getBoundingClientRect();
      const cellRect = firstCell.getBoundingClientRect();
      columnLeft = cellRect.left - tableRect.left; // Position relative to the table wrapper
      columnWidth = cellRect.width;
    }

    // Calculate total height using the first and last cells
    const lastCell = secondColumnCells[secondColumnCells.length - 1];
    if (firstCell && lastCell) {
      const tableRect = document.querySelector('.table-compare .pc-table_wrapper').getBoundingClientRect();
      const firstCellRect = firstCell.getBoundingClientRect();
      const lastCellRect = lastCell.getBoundingClientRect();
      // Height from the top of the first cell to the bottom of the last cell
      totalColumnHeight = lastCellRect.bottom - firstCellRect.top;
      // Adjust top position to the top of the first cell relative to the wrapper
      const columnTop = firstCellRect.top - tableRect.top;
      shadowElement.style.top = columnTop + 'px';
    } else if (firstCell) {
       // Fallback if there's only one cell or issues getting the last
       totalColumnHeight = firstCell.offsetHeight;
       const tableRect = document.querySelector('.table-compare .pc-table_wrapper').getBoundingClientRect();
       const firstCellRect = firstCell.getBoundingClientRect();
       const columnTop = firstCellRect.top - tableRect.top;
       shadowElement.style.top = columnTop + 'px';
    }

    // Apply styles to the shadow element
    shadowElement.style.left = columnLeft + 'px';
    shadowElement.style.width = columnWidth + 'px';
    shadowElement.style.height = totalColumnHeight + 'px';
  }

  // Initial positioning
  updateShadowPosition();

  // Update position on window resize
  window.addEventListener('resize', updateShadowPosition);
});
